import { client } from '../common/client';
import { PAGE_ENDPOINTS } from './utils/endpoints';
import type {
  GetPageMetaRequest,
  GetPageMetaResponse,
  GetCollectionDetailRequest,
  GetCollectionDetailResponse,
} from './utils/types';

const PAGE_META_NOT_FOUND_STATUS = 404;

export class PageAPIClient {
  public async getPageMeta(params: GetPageMetaRequest): Promise<GetPageMetaResponse> {
    const fallback: GetPageMetaResponse = {
      postId: 0,
      title: 'SkinSeoul',
      description: 'Korean Beauty Products',
      type: 'website',
      url: `https://skin-seoul.com${params.pathname}`,
    };
    try {
      const response = await client.get(`/page/meta`, {
        params: {
          path: params.pathname,
          ...(params.currency ? { currency: params.currency } : {}),
        },
        // Routes WordPress does not know (account pages, login) have no meta. That answer is a
        // 404, which is not a failure: accepting it here keeps it out of the error log that the
        // dev overlay surfaces on every such page.
        validateStatus: (status) => (status >= 200 && status < 300) || status === PAGE_META_NOT_FOUND_STATUS,
      });

      if (response.status === PAGE_META_NOT_FOUND_STATUS) {
        return fallback;
      }

      return response.data;
    } catch (_error) {
      return fallback;
    }
  }

  /**
   * Fetch collection detail by slug
   * @param params - Collection detail request parameters
   * @returns Promise with collection detail data
   */
  public async getCollectionDetail(params: GetCollectionDetailRequest): Promise<GetCollectionDetailResponse> {
    return await client.get(PAGE_ENDPOINTS.collectionDetail, { params }).then((res) => res.data);
  }
}

export const pageAPIClient = new PageAPIClient();
